<template>
  <div id="Admin_QueryDuplicate">
    <!-- 銷帳明細表 -->
    <div
      id="sales_query"
      class="tab-pane fade show active"
      role="tabpanel"
      aria-labelledby="sales_query"
    >
      <div class="col-12 pt-2 table-style">
        <v-query-layout>
          <!-- 1 -->
          <v-label slot="ql1-text-1" for="query-keyword" LabText="篩選資料：" Labbold="true" />
          <input
            id="query-keyword"
            class="input-style"
            type="text"
            slot="ql1-input-1"
            placeholder="請輸入關鍵字"
            v-model="filter"
          />
          <v-label slot="ql1-text-2" for="query-on" LabText="繳款項目編號：" Labbold="true" />
          <input
            id="query-on"
            class="input-style"
            type="text"
            slot="ql1-input-2"
            placeholder="請輸入繳款項目編號"
            v-model="QueryData.FeeOrderId"
          />
          <v-label slot="ql2-text-1" for="query-on2" LabText="繳費單號：" Labbold="true" />
          <input
            id="query-on2"
            class="input-style"
            type="text"
            slot="ql2-input-1"
            placeholder="請輸入繳費單號"
            v-model="QueryData.PayOrderId"
          />
          <v-label
            slot="ql2-text-2"
            for="query-paytype"
            class="ml-2"
            LabText="重複繳費方式："
            Labbold="true"
          />
          <select
            id="query-paytype"
            class="input-style"
            slot="ql2-input-2"
            v-model="QueryData.PayType2"
          >
            <option value disabled>-請選擇-</option>
            <option v-for="Pay in PayApproachSelect" :key="Pay.id" :value="Pay.value">{{ Pay.text }}</option>
          </select>
          <v-label slot="ql3-text-1" LabText="起始日：" Labbold="true" />
          <a-locale-provider slot="ql3-input-1" :locale="zhTW">
            <a-date-picker
              size="large"
              @change="onPayDTStart"
              :format="dateFormat"
              v-model="timePayDTStart"
            />
          </a-locale-provider>
          <v-label slot="ql3-text-2" class="ml-2" LabText="結束日：" Labbold="true" />
          <a-locale-provider slot="ql3-input-2" :locale="zhTW">
            <a-date-picker
              size="large"
              @change="onPayDTEnd"
              :format="dateFormat"
              v-model="timePayDTEnd"
            />
          </a-locale-provider>
          <div slot="qcbutton3">
            <v-button class="ml-2" btn-text="查詢" btnOutline="primary" @click.native="Query">
              <font-awesome-icon slot="icon" icon="search" />
            </v-button>
            <v-button class="ml-2" btn-text="清除" btnOutline="secondary" @click.native="Clear">
              <font-awesome-icon slot="icon" icon="search-minus" />
            </v-button>
          </div>
          <!-- 4 -->
          <v-label slot="ql4-text-1" LabText="功能：" Labbold="true" />
          <div slot="ql4-input-1">
            <v-button
              v-if="items.length !== 0"
              btn-text="匯出報表"
              title="匯出報表"
              btnType="warning"
              data-toggle="modal"
              data-target="#queryexport"
            >
              <font-awesome-icon slot="icon" icon="chart-bar" size="sm" />
            </v-button>
          </div>
          <v-label slot="ql4-text-2" for="query-page" class="ml-2" LabText="筆數：" Labbold="true" />
          <v-page slot="ql4-input-2" id="query-page" @RecPerPage="RecPerPage" />
        </v-query-layout>
        <hr />
        <template>
          <b-table
            hover
            small
            bordered
            responsive
            empty-text="目前無資料"
            :items="items"
            :filter="filter"
            :fields="fields"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :current-page="currentPage"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <!-- 姓名(套特殊字型) -->
            <template v-slot:cell(UserName)="data">
              <span class="nukWord">{{ data.item.UserName }}</span>
            </template>
            <!-- 繳費金額 -->
            <template v-slot:cell(PayAmt)="data">{{ data.item.PayAmt + ' 元' }}</template>
            <!-- 手續費 -->
            <template v-slot:cell(PayCharge)="data">{{ data.item.PayCharge + ' 元' }}</template>
            <!-- 繳費方式 -->
            <template v-slot:cell(PayType)="data">
              <div v-for="Select in PayApproachSelect" :key="Select.id" :value="Select.value">
                <div v-if="Select.value === String(data.item.PayType)">{{ Select.text }}</div>
              </div>
            </template>
            <!-- 繳費方式2 -->
            <template v-slot:cell(PayType2)="data">
              <div v-for="Select in PayApproachSelect" :key="Select.id" :value="Select.value">
                <div v-if="Select.value === String(data.item.PayType2)">{{ Select.text }}</div>
              </div>
            </template>
          </b-table>
          <br />
          <!-- 分頁 -->
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0 mb-2"
          />
        </template>
        <!-- 匯出Model -->
        <v-modal id="queryexport">
          <div slot="header">重複繳費清單</div>
          <div slot="footer">
            <v-button btn-text="確認匯出" btnType="primary" @click.native="PostReportDetailexport" />
            <v-button
              class="ml-1"
              btn-text="取消"
              btnType="secondary"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
        </v-modal>
      </div>
      <br />
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import md5 from 'js-md5'
import moment from 'moment'
import {
  apiReportQueryduplicate,
  apiReportDuplicateexport
} from '../../../Api/api'
import vModal from '@/components/Features/ModalFloot'
import vLabel from '@/components/Features/Label'
import vQueryLayout from '@/components/Layout/QueryLayout'
import zhTW from 'ant-design-vue/lib/locale-provider/zh_TW'
import 'ant-design-vue/lib/date-picker/style/css'
export default {
  name: 'Admin_QueryDuplicate',
  components: {
    'v-modal': vModal,
    'v-label': vLabel,
    'v-query-layout': vQueryLayout
  },
  data () {
    return {
      items: [],
      fields: [
        { key: 'SerialNo', label: '#', thClass: 'table-th' },
        { key: 'FeeItemId', label: '收費項目識別碼', thClass: 'table-th' },
        { key: 'FeeItemName', label: '收費項目名稱', thClass: 'table-th' },
        { key: 'FeeOrderId', label: '繳款項目編號', thClass: 'table-th' },
        { key: 'PayOrderId', label: '繳費單號', thClass: 'table-th' },
        { key: 'UserName', label: '繳款人', thClass: 'table-th' },
        { key: 'Email', label: 'Email', thClass: 'table-th' },
        { key: 'Telephone', label: '電話', thClass: 'table-th' },
        { key: 'PayAmt', label: '繳費金額', thClass: 'table-th' },
        { key: 'PayCharge', label: '手續費', thClass: 'table-th' },
        { key: 'PayType', label: '繳費方式', thClass: 'table-th' },
        { key: 'PayDT', label: '繳費時間', thClass: 'table-th' },
        { key: 'PayType2', label: '繳費方式2', thClass: 'table-th' },
        { key: 'PayDT2', label: '繳費時間2', thClass: 'table-th' }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      QueryData: {
        FeeOrderId: '',
        PayOrderId: '',
        PayType2: null,
        PayDT2Start: '',
        PayDT2End: ''
      },
      QueryDataed: {},
      PayApproachSelect: [
        { value: '1', text: '國內信用卡' },
        { value: '2', text: '國外信用卡' },
        { value: '3', text: '一卡通' },
        { value: '4', text: 'LINE Pay' },
        { value: '5', text: 'WebATM' },
        { value: '6', text: '四大超商繳款' },
        { value: '7', text: '土銀臨櫃繳款' },
        { value: '8', text: '出納組現金繳納' }
      ],
      zhTW,
      dateFormat: 'YYYY/MM/DD',
      monthFormat: 'YYYY/MM',
      timeDebtDate: undefined,
      timePayDTStart: undefined,
      timePayDTEnd: undefined,
      checkDate: new Date()
    }
  },
  mounted () {
    this.InquireFeeitemQuery()
  },
  methods: {
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    RecPerPage (SublayerPage) {
      // 組件筆數
      this.perPage = SublayerPage
    },
    InquireFeeitemQuery () {
      // 查詢條件
      // 定義資料
      const vm = this
      var NewData
      // API預設資料
      const IdentityData = JSON.parse(sessionStorage.getItem('Identity'))
      // 查詢條件
      const QueryDuplicate = JSON.parse(
        sessionStorage.getItem('QueryDuplicate')
      )
      // 判斷帳號身分
      const Backend = md5('管理者')
      if (Backend === sessionStorage.getItem('Backend')) {
        vm.Backend = true
        if (!QueryDuplicate) {
          // 沒查詢條件，不打API
          vm.items = []
          return false
        } else {
          vm.QueryData = QueryDuplicate
          vm.timeDebtDate =
            QueryDuplicate.timeDebtDate === 'undefined'
              ? undefined
              : moment(QueryDuplicate.timeDebtDate, vm.dateFormat)
          vm.timePayDTStart =
            QueryDuplicate.timePayDTStart === 'undefined'
              ? undefined
              : moment(QueryDuplicate.timePayDTStart, vm.dateFormat)
          vm.timePayDTEnd =
            QueryDuplicate.timePayDTEnd === 'undefined'
              ? undefined
              : moment(QueryDuplicate.timePayDTEnd, vm.dateFormat)
          NewData = Object.assign(IdentityData, QueryDuplicate)
        }
      } else {
        vm.ErrorModal('權限不足，無法使用此頁面')
        return false
      }
      // 呼叫API
      apiReportQueryduplicate(NewData).then(res => {
        if (res !== undefined) {
          for (let index = 0; index < res.Data.length; index++) {
            const json = res.Data[index]
            json.SerialNo = index + 1
          }
          vm.items = res.Data
          vm.totalRows = res.Data.length
        } else {
          $('#CheckError').modal('show')
        }
      })
    },
    PostReportDetailexport () {
      // 匯出_銷帳明細表 B_API 020
      // 定義資料
      $('#queryexport').modal('hide')
      var NewData
      const IdentityData = JSON.parse(sessionStorage.getItem('Identity'))
      NewData = Object.assign(IdentityData, this.QueryData)
      // 呼叫API
      apiReportDuplicateexport(NewData).then(res => {
        if (res !== undefined) {
          const url = res.FileDir + '/' + res.FileName
          window.open(url)
        } else {
          $('#CheckError').modal('show')
        }
      })
    },
    onPayDTStart (date, dateString) {
      // 繳費時間(起)
      this.timeDebtDate = date
      this.QueryData.PayDT2Start = dateString
    },
    onPayDTEnd (date, dateString) {
      // 繳費時間(迄)
      this.timePayDTEnd = date
      this.QueryData.PayDT2End = dateString
    },
    Query () {
      // 查詢條件
      // 定義資料
      var NewData
      const vm = this
      const IdentityData = JSON.parse(sessionStorage.getItem('Identity'))
      NewData = Object.assign(IdentityData, vm.QueryData)
      delete NewData.timeDebtDate
      delete NewData.timePayDTEnd
      delete NewData.timePayDTStart
      vm.items = []
      // 紀錄查詢條件
      vm.QueryDataed = {}
      vm.QueryDataed = vm.QueryData
      vm.QueryDataed.timeDebtDate =
        vm.timeDebtDate === undefined || vm.timeDebtDate === null
          ? 'undefined'
          : vm.timeDebtDate
      vm.QueryDataed.timePayDTStart =
        vm.timePayDTStart === undefined || vm.timePayDTStart === null
          ? 'undefined'
          : vm.timePayDTStart
      vm.QueryDataed.timePayDTEnd =
        vm.timePayDTEnd === undefined || vm.timePayDTEnd === null
          ? 'undefined'
          : vm.timePayDTEnd
      sessionStorage.setItem('QueryDuplicate', JSON.stringify(vm.QueryDataed))
      // 呼叫API
      apiReportQueryduplicate(NewData).then(res => {
        if (res !== undefined) {
          for (let index = 0; index < res.Data.length; index++) {
            const json = res.Data[index]
            json.SerialNo = index + 1
          }
          vm.items = res.Data
          vm.totalRows = res.Data.length
        } else {
          $('#CheckError').modal('show')
        }
      })
    },
    Clear () {
      // 清除查詢條件
      const vm = this
      sessionStorage.removeItem('QueryDuplicate')
      vm.QueryData = {
        FeeOrderId: '',
        PayOrderId: '',
        PayType2: null,
        PayDT2Start: '',
        PayDT2End: ''
      }
      vm.timeDebtDate = undefined
      vm.timePayDTStart = undefined
      vm.timePayDTEnd = undefined
      vm.items = []
      vm.InquireFeeitemQuery()
    },
    ErrorModal (data) {
      // 錯誤彈跳視窗
      this.$bus.$emit('Modals', data)
      $('#CheckError').modal('show')
    }
  }
}
</script>

<style>
#queryexport .modal-body {
  display: none;
}
</style>
